<div *ngIf="loading" class="graph loading" id="performanceChart" [chart]="performanceChart"></div>
<div *ngIf="!loading" class="graph" id="performanceChart" [chart]="performanceChart" [class.loading]="loading"></div>